<template>
  <dialog-full-screen :dialog="adminTrainingDialog" titleName="Treino" @close="closeDialog()">
    <v-container>

      <template>
        <v-row no-gutters>
          <v-slide-group>
            <v-col cols="auto" class="pr-2" v-for="(weekday, idx) in week" :key="idx">
              <v-card width="163px" height="100%">
                <v-card-title class="justify-center"
                  :class="isEmptyWeekdayTraining(weekday, trainingToBeEvaluated.trainings) ? 'lightgrey text--secondary' : 'secondary white--text'">
                  {{ weekday.name }}
                </v-card-title>
                <template v-if="isEmptyWeekdayTraining(weekday, trainingToBeEvaluated.trainings)">
                  <v-img contain height="72px" class="mt-8"
                    :src="require('@/assets/images/students/show/no-data-training.svg')"></v-img>
                  <v-card-text class="text-center mb-0 caption">
                    Não há treino neste dia.
                  </v-card-text>
                </template>
                <template v-else>
                  <v-row justify="center" class="mx-0 grey lighten-4">
                    <v-subheader>
                      <span class="primary--text font-weight-bold justify-center">{{
                        getMuscleGroupSeriesFromWeekday(weekday,
                          trainingToBeEvaluated.trainings).name }}</span>
                    </v-subheader>
                  </v-row>
                  <template
                    v-if="getMuscleGroupSeriesFromWeekday(weekday, trainingToBeEvaluated.trainings).worked_muscle_groups.length">
                    <v-row class="pa-0 px-3 mt-n4" style="font-size: 10px;">
                      <v-col class="grey lighten-4" cols="8">Grupo muscular</v-col>
                      <v-col class="grey lighten-4 text-right" cols="4">Séries</v-col>
                    </v-row>
                    <v-list-item
                      v-for="(workedMuscleGroup, idx) in getMuscleGroupSeriesFromWeekday(weekday, trainingToBeEvaluated.trainings).worked_muscle_groups"
                      :key="`muscle-group${idx}`">
                      <v-list-item-subtitle class="text-left">{{ workedMuscleGroup.name }} </v-list-item-subtitle>
                      <v-list-item-action class="pl-8 ml-n8">{{ workedMuscleGroup.seriesAmount }} </v-list-item-action>
                    </v-list-item>
                  </template>
                  <template v-else>
                    <template
                      v-if="getMuscleGroupSeriesFromWeekday(weekday, trainingToBeEvaluated.trainings).exercisesCount">
                      <v-img contain height="72px" class="mt-8"
                        :src="require('@/assets/images/students/show/no-resistence-training.svg')"></v-img>
                      <v-card-text class="text-center mb-0 caption">
                        Não há exercícios resistidos neste treino.
                      </v-card-text>
                    </template>
                    <template v-else>
                      <v-img contain height="72px" class="mt-8"
                        :src="require('@/assets/images/students/show/no-data-training.svg')"></v-img>
                      <v-card-text class="text-center mb-0 caption">
                        Não há exercícios neste treino.
                      </v-card-text>
                    </template>
                  </template>
                </template>
              </v-card>
            </v-col>
          </v-slide-group>
        </v-row>

        <v-row class="d-flex align-center">
          <v-col cols="8">
            <v-tabs min-width="90px" v-model="tabs" background-color="white" class="training-tabs">
              <v-tab v-for="(training, index) in trainingToBeEvaluated.trainings" :key="index">
                {{ training.name }}
              </v-tab>
            </v-tabs>
          </v-col>
          <v-col class="text-right">
            <v-btn color="primary" @click="downloadCurrentTrainingPdf()">
              <span class="ml-1">Baixar PDF</span>
            </v-btn>
            <v-btn class="ml-5 elevation-3" color="secondary" text @click="newTraining()" v-if="!readOnlyForPersonal && !readonly">
              <span class="ml-1">Novo Treino</span>
            </v-btn>
          </v-col>
        </v-row>

        <v-tabs-items v-model="tabs">
          <v-tab-item v-for="(training, idx) in trainingToBeEvaluated.trainings" :key="idx">
            <v-container>
              <v-row class="d-flex justify-center">
                <v-col>
                  <span class="title">
                    {{ training.name }}
                  </span>
                  <template v-if="!readOnlyForPersonal && !readonly">
                    <v-btn class="ml-2 elevation-4" fab x-small color="secondary"
                      @click="selectTrainingToBeDestroyed(idx)" text>
                      <v-icon>mdi-delete</v-icon>
                    </v-btn>
                    <v-btn  class="ml-2 elevation-4" fab x-small color="secondary" text
                      @click="editTraining(training, idx)">
                      <v-icon>mdi-pencil</v-icon>
                    </v-btn>
                  </template>
                </v-col>
                <v-spacer />
                <v-col class="text-right" v-if="!readOnlyForPersonal && !readonly">
                  <v-btn color="primary" @click="newExerciseDialog(idx, null)">
                    ADICIONAR EXERCÍCIO
                  </v-btn>
                </v-col>
              </v-row>
              <v-row>
                <v-col>
                  <admin-training-table v-for="exerciseType in getExercisesByType(idx)" :title="exerciseType.title"
                    :headers="exerciseType.headers" :items="exerciseType.items" :readonly="readonly" :readOnlyForPersonal="readOnlyForPersonal"
                    :trainingIndex="idx" @destroyExerciseDialog="openConfirmationDestroyExerciseDialog"
                    @copyExerciseDialog="openConfirmationCopyExerciseDialog" :key="exerciseType.title" />
                </v-col>
              </v-row>
            </v-container>
          </v-tab-item>
        </v-tabs-items>
      </template>
    </v-container>

    <confirm-dialog title="Atenção" message="Deseja remover o treino selecionado? Essa ação não poderá ser desfeita"
      cancelButton="Cancelar" confirmButton="Remover" :confirmationDialog="confirmationDialog" @confirm="destroy()"
      @cancel="closeConfirmationDialog()" />

    <confirm-dialog title="Atenção" message="Deseja remover o exercício selecionado? Essa ação não poderá ser desfeita"
      cancelButton="Cancelar" confirmButton="Remover" :confirmationDialog="confirmationDestroyExerciseDialog"
      @confirm="removeExercise()" @cancel="closeConfirmationDestroyExerciseDialog()" />

    <confirm-dialog title="Atenção" message="Deseja adicionar o treino selecionado à sua biblioteca de treinos?"
      cancelButton="Cancelar" confirmButton="Adicionar" :confirmationDialog="confirmationDialogLibrary" @confirm="saveTrainingToLibrary()" @cancel="closeConfirmationLibraryDialog()" />

    <create-or-update-training-library-dialog :dialog.sync="createOrUpdateTrainingLibraryDialog" :editedItem="currentTrainingAdmin"
      :editedIndex="currentTrainingAdminIndex" @update="update" />

    <copy-training-admin-dialog :dialog.sync="confirmationCopyExerciseAdminDialog" :editedItem="exerciseToBeCopied"
      :editedIndex="currentTrainingAdminIndex" @update="update" />
  </dialog-full-screen>
</template>

<script>
import DialogFullScreen from '@/components/base/DialogFullScreen'
import ConfirmDialog from '@/components/base/ConfirmDialog'
import CreateOrUpdateTrainingLibraryDialog from '@/components/admin/configurations/trainings/CreateOrUpdateTrainingLibraryDialog'
import CopyTrainingAdminDialog from '@/components/admin/configurations/trainings/CopyTrainingAdminDialog'
import AdminTrainingTable from '@/components/admin/configurations/trainings/AdminTrainingTable'

import DocumentService from '@/services/document-service.js'
// import StudentService from '@/services/student-service.js'
// import MesocycleService from '@/services/mesocycle-service.js'
// import LibraryService from '@/services/user-library-service'
import { mapGetters, mapActions } from 'vuex'
import { filter } from 'lodash'

export default {
  props: {
    readOnlyForPersonal: {
      type: Boolean,
      default: false
    }
  },
  name: 'admin-training-detail',
  components: {
    DialogFullScreen,
    ConfirmDialog,
    CreateOrUpdateTrainingLibraryDialog,
    AdminTrainingTable,
    CopyTrainingAdminDialog
  },
  data () {
    return {
      week: [
        { name: 'Domingo', id: 0 },
        { name: 'Segunda', id: 1 },
        { name: 'Terça', id: 2 },
        { name: 'Quarta', id: 3 },
        { name: 'Quinta', id: 4 },
        { name: 'Sexta', id: 5 },
        { name: 'Sábado', id: 6 }
      ],
      mesocycles: [],
      name: '',
      mesoCopy: '',
      studentcopy: '',
      studentSel: '',
      thisStudent: true,
      createOrUpdateTrainingLibraryDialog: false,
      currentTrainingAdminIndex: -1,
      currentTrainingAdmin: {},
      onEditTraining: false,
      tabs: null,
      confirmationDialog: false,
      confirmationDestroyExerciseDialog: false,
      trainingToBeDestroyedIndex: -1,
      confirmationDialogLibrary: false,
      trainingToLibrary: {},
      exerciseToBeDestroyed: null,
      exerciseToBeCopied: null,
      confirmationCopyExerciseAdminDialog: false,
      trainingsFromLibrary: [],
      resistanceHeader: [
        { text: '', sortable: false, value: 'draggable', width: '50' },
        { text: 'Exercício', align: 'left', sortable: false, value: 'exercise.name', width: '300' },
        { text: 'Séries', align: 'center', sortable: false, value: 'series', width: '70' },
        { text: 'Min. Repetições', align: 'center', sortable: false, value: 'min_reps', width: '100' },
        { text: 'Max. Repetições', align: 'center', sortable: false, value: 'max_reps', width: '100' },
        { text: 'Descanso', align: 'center', sortable: false, value: 'descanco', width: '100' },
        { text: 'Cadência', align: 'center', sortable: false, value: 'cadencia', width: '100' },
        { text: 'Técnica de Intensificação', align: 'center', sortable: false, value: 'exercise_technic.name', width: '100' },
        { text: 'Grupos Musculares', align: 'center', sortable: false, value: 'muscleGroups', width: '150' },
        { text: '', align: 'left', sortable: false, value: 'actions', width: '90' }
      ],
      stretchingHeader: [
        { text: '', sortable: false, value: 'draggable', width: '50' },
        { text: 'Exercício', align: 'left', sortable: false, value: 'exercise.name', width: '350' },
        { text: 'Séries', align: 'center', sortable: false, value: 'series', width: '100' },
        { text: 'Tempo', align: 'center', sortable: false, value: 'quantidade_tiros', width: '100' },
        { text: 'Descanso', align: 'center', sortable: false, value: 'descanco', width: '100' },
        { text: '', align: 'left', sortable: false, value: 'actions', width: '191' }
      ],
      mobilityHeader: [
        { text: '', sortable: false, value: 'draggable', width: '50' },
        { text: 'Exercício', align: 'left', sortable: false, value: 'exercise.name', width: '432' },
        { text: 'Séries', align: 'center', sortable: false, value: 'series', width: '100' },
        { text: 'Repetições', align: 'center', sortable: false, value: 'min_reps', width: '100' },
        { text: 'Descanso', align: 'center', sortable: false, value: 'descanco', width: '200' },
        { text: '', align: 'left', sortable: false, value: 'actions', width: '110' }
      ],
      myofascialReleaseHeader: [
        { text: '', sortable: false, value: 'draggable', width: '50' },
        { text: 'Exercício', align: 'left', sortable: false, value: 'exercise.name', width: '350' },
        { text: 'Séries', align: 'center', sortable: false, value: 'series', width: '130' },
        { text: 'Tempo Liberação', align: 'center', sortable: false, value: 'tempo', width: '170' },
        { text: 'Intervalo', align: 'center', sortable: false, value: 'descanco', width: '100' },
        { text: 'Grupos Musculares', align: 'center', sortable: false, value: 'muscleGroups', width: '210' },
        { text: '', align: 'left', sortable: false, value: 'actions', width: '190' }
      ],
      functionalHeader: [
        { text: '', sortable: false, value: 'draggable', width: '50' },
        { text: 'Exercício', align: 'left', sortable: false, value: 'exercise.name', width: '300' },
        { text: 'Min. Repetições', align: 'center', sortable: false, value: 'min_reps', width: '100' },
        { text: 'Max. Repetições', align: 'center', sortable: false, value: 'max_reps', width: '100' },
        { text: 'Grupos Musculares', align: 'center', sortable: false, value: 'muscleGroups', width: '150' },
        { text: '', align: 'left', sortable: false, value: 'actions', width: '90' }
      ],
      AerobicoContHeader: [
        { text: '', sortable: false, value: 'draggable', width: '50' },
        { text: 'Exercício', align: 'left', sortable: false, value: 'exercise.name', width: '300' },
        { text: 'Sprints', align: 'center', sortable: false, value: 'quantidade_tiros', width: '100' },
        { text: 'Duração da Sprint', align: 'center', sortable: false, value: 'tempo', width: '75' },
        { text: 'Intervalo entre Sprints', align: 'center', sortable: false, value: 'intervalo_tiros', width: '150' },
        { text: 'Freq Cardíaca', align: 'center', sortable: false, value: 'freqCardiaca', width: '100' },
        { text: 'Hiit', align: 'center', sortable: false, value: 'hiit', width: '50' },
        { text: 'Aeróbico Continuado', align: 'center', sortable: false, value: 'aerobicocont', width: '100' },
        { text: '', align: 'left', sortable: false, value: 'actions', width: '90' }
      ],
      ManobrasContHeader: [
        { text: '', align: 'left', sortable: false, value: 'draggable', width: '50' },
        { text: 'Exercício', align: 'left', sortable: false, value: 'exercise.name', width: '350' },
        { text: 'Repetições em Isometria', align: 'center', sortable: false, value: 'series', width: '130' },
        { text: 'Tempo de Cada Repetição', align: 'center', sortable: false, value: 'tempo', width: '170' },
        { text: 'Intervalo entre Cada Repetição', align: 'center', sortable: false, value: 'descanco', width: '170' },
        { text: '', align: 'left', sortable: false, value: 'actions', width: '300' }
      ]
    }
  },
  methods: {
    ...mapActions('base', ['fetchPdf']),
    ...mapActions('admin', [
      'setTrainingAdminDialog',
      'destroyTrainingAdmin',
      'setTrainingAdminIndex',
      'setCreateOrUpdateExerciseAdminDialog',
      'destroyExerciseAdmin',
      'setCreateOrUpdateExerciseAdmin',
      'setCreateOrUpdateExerciseAdminIndex'
    ]),
    ...mapActions('base', ['setSnackbar', 'setLoader']),
    newExerciseDialog (trainingIndex, exercise) {
      this.setTrainingAdminIndex(trainingIndex)
      this.setCreateOrUpdateExerciseAdmin(exercise)
      const exerciseIndex = this.trainingToBeEvaluated.trainings[trainingIndex].exercises.indexOf(exercise)
      this.setCreateOrUpdateExerciseAdminIndex(exerciseIndex)
      this.setCreateOrUpdateExerciseAdminDialog(false)
      this.setCreateOrUpdateExerciseAdminDialog(true)
    },
    newTraining () {
      this.createOrUpdateTrainingLibraryDialog = true
      this.currentTrainingAdmin = Object.assign({}, {})
      this.currentTrainingAdminIndex = -1
    },
    editTraining (training, index) {
      this.createOrUpdateTrainingLibraryDialog = true
      this.currentTrainingAdmin = Object.assign({}, training)
      this.currentTrainingAdminIndex = index
    },
    closeDialog () {
      this.setTrainingAdminDialog(false)
      this.currentTrainingAdmin = {}
      this.createOrUpdateTrainingLibraryDialog = false
    },
    update (successMessage, failMessage) {
      this.$emit('update', { successMessage, failMessage })
    },
    selectTrainingToBeDestroyed (idx) {
      this.confirmationDialog = true
      this.trainingToBeDestroyedIndex = idx
    },
    // destroy () {
    //   this.setLoader({ show: true })
    //   MesocycleService.removeTraining(this.trainingToBeEvaluated.id, this.trainingToBeDestroyedIndex)
    //     .then(() => {
    //       this.destroyTrainingAdmin({ trainingIndex: this.trainingToBeDestroyedIndex, cycle: 'meso' })
    //       this.setSnackbar({
    //         show: true,
    //         color: 'success',
    //         message: 'Treino removido com sucesso'
    //       })
    //       this.closeConfirmationDialog()
    //     })
    //     .catch(({ response }) => {
    //       this.setSnackbar({
    //         color: 'error',
    //         show: true,
    //         message: response.data.errors.detail
    //       })
    //     })
    //     .finally(() => {
    //       this.setLoader({ show: false })
    //     })
    // },
    closeConfirmationDialog () {
      this.confirmationDialog = false
    },
    openConfirmationDestroyExerciseDialog (exercise) {
      this.exerciseToBeDestroyed = exercise
      this.confirmationDestroyExerciseDialog = true
    },
    closeConfirmationDestroyExerciseDialog () {
      this.exerciseToBeDestroyed = null
      this.confirmationDestroyExerciseDialog = false
    },
    openConfirmationCopyExerciseDialog (exercise, index) {
      this.currentTrainingAdminIndex = index
      this.exerciseToBeCopied = exercise
      this.confirmationCopyExerciseAdminDialog = true
    },
    closeConfirmationCopyExerciseDialog () {
      this.currentTrainingAdminIndex = -1
      this.exerciseToBeCopied = null
      this.confirmationCopyExerciseAdminDialog = false
    },
    getExercisesByType (idx) {
      const exercises = []
      if (this.stretchingExercises(idx) && this.stretchingExercises(idx).length) {
        exercises.push({ title: 'Alongamentos', headers: this.stretchingHeader, items: this.stretchingExercises(idx) })
      }
      if (this.mobilityExercises(idx) && this.mobilityExercises(idx).length) {
        exercises.push({ title: 'Mobilidade', headers: this.mobilityHeader, items: this.mobilityExercises(idx) })
      }
      if (this.myofascialReleaseExercises(idx) && this.myofascialReleaseExercises(idx).length) {
        exercises.push({ title: 'Liberação Miofascial', headers: this.myofascialReleaseHeader, items: this.myofascialReleaseExercises(idx) })
      }
      if (this.functionalExercises(idx) && this.functionalExercises(idx).length) {
        exercises.push({ title: 'Exercícios Funcionais', headers: this.functionalHeader, items: this.functionalExercises(idx) })
      }
      if (this.resistanceExercises(idx) && this.resistanceExercises(idx).length) {
        exercises.push({ title: 'Treinos Resistidos', headers: this.resistanceHeader, items: this.resistanceExercises(idx) })
      }
      if (this.respExercises(idx) && this.respExercises(idx).length) {
        exercises.push({ title: 'Manobras Respiratórias/core', headers: this.ManobrasContHeader, items: this.respExercises(idx) })
      }
      if (this.respaerobic(idx) && this.respaerobic(idx).length) {
        exercises.push({ title: 'Exercícios Aeróbicos', headers: this.AerobicoContHeader, items: this.respaerobic(idx) })
      }

      // console.log(exercises)
      return exercises
    },
    removeExercise () {
      const exerciseIndex = this.trainingToBeEvaluated.trainings[this.tabs].exercises.findIndex(exercise => {
        if (Array.isArray(exercise.exercise)) {
          return exercise.exercise.some(ex =>
            ex.id === (Array.isArray(this.exerciseToBeDestroyed.exercise)
              ? this.exerciseToBeDestroyed.exercise[0].id
              : this.exerciseToBeDestroyed.exercise.id)
          )
        } else {
          return exercise.exercise.id === (Array.isArray(this.exerciseToBeDestroyed.exercise)
            ? this.exerciseToBeDestroyed.exercise[0].id
            : this.exerciseToBeDestroyed.exercise.id)
        }
      })

      if (exerciseIndex >= 0) {
        this.destroyExerciseAdmin({ trainingIndex: this.tabs, exerciseIndex })
        this.update('Exercício removido com sucesso', 'Erro ao remover Exercício')
      } else {
        console.error('Exercício não encontrado para deleção:', this.exerciseToBeDestroyed)
        this.setSnackbar({
          color: 'error',
          show: true,
          message: 'Erro: Exercício não encontrado para remoção'
        })
      }
      this.closeConfirmationDestroyExerciseDialog()
    },
    downloadCurrentTrainingPdf () {
      if (!this.trainingToBeEvaluated || !this.trainingToBeEvaluated.trainings || this.trainingToBeEvaluated.trainings.length === 0) {
        this.setSnackbar({
          color: 'error',
          show: true,
          message: 'Erro: Nenhum treino disponível para download.'
        })
        this.setLoader({ show: false })
        return
      }

      const payload = {
        trainingLibrary: this.trainingToBeEvaluated.id
      }

      const trainingName = this.trainingToBeEvaluated.trainings && this.trainingToBeEvaluated.trainings.length > 0
        ? this.trainingToBeEvaluated.trainings[this.tabs]?.name || 'sem nome'
        : 'sem nome'
      const tag = Object.values(payload).join('.')
      const fileName = `${tag} - ${trainingName}.pdf`

      this.setLoader({ show: true })
      this.fetchPdf({ service: DocumentService.getTrainingLibraryPdf, payload, fileName })
        .then(() => {
          console.log('PDF baixado com sucesso')
        })
        .catch(error => {
          const errorMessage = error.response && error.response.data && error.response.data.errors && error.response.data.errors.detail
            ? error.response.data.errors.detail
            : error.message || 'Erro desconhecido ao baixar PDF'
          this.setSnackbar({
            color: 'error',
            show: true,
            message: `Erro ao baixar PDF: ${errorMessage}`
          })
        })
        .finally(() => {
          this.setLoader({ show: false })
        })
    },
    isEmptyWeekdayTraining (weekday, trainings) {
      try {
        if (!Array.isArray(trainings) || trainings.length === 0) {
          return true
        }

        const idx = trainings.findIndex(training => {
          return Array.isArray(training.weekdays) && training.weekdays.some(w => Number(w) === weekday.id)
        })
        return idx === -1
      } catch (error) {
        return true
      }
    },
    getMuscleGroupSeriesFromWeekday (weekday, trainings) {
      var muscleGroups = {}
      var idx
      try {
        if (!Array.isArray(trainings) || trainings.length === 0) {
          return { name: 'Sem Treino', worked_muscle_groups: [], exercisesCount: 0 }
        }
        idx = trainings.findIndex(training => {
          return Array.isArray(training.weekdays) && training.weekdays.some(w => Number(w) === weekday.id)
        })

        if (idx === -1) {
          return { name: 'Sem Treino', worked_muscle_groups: [], exercisesCount: 0 }
        }

        const training = trainings[idx]

        training.exercises.forEach(trainingExercise => {
          const exerciseArray = Array.isArray(trainingExercise.exercise) ? trainingExercise.exercise : [trainingExercise.exercise]
          exerciseArray.forEach(ex => {
            if (ex && Array.isArray(ex.muscle_group)) {
              ex.muscle_group.forEach(muscleGroup => {
                const exerciseMuscleGroup = muscleGroup.name
                if (!muscleGroups[exerciseMuscleGroup]) {
                  muscleGroups[exerciseMuscleGroup] = 0
                }
                if (ex.exercise_type === 'resistence') {
                  muscleGroups[exerciseMuscleGroup] += parseInt(trainingExercise.series) || 1
                }
              })
            }
          })
        })

        const workedMuscleGroups = Object.keys(muscleGroups).map(muscleGroup => ({
          name: muscleGroup,
          seriesAmount: muscleGroups[muscleGroup]
        }))

        return {
          name: training.name,
          worked_muscle_groups: workedMuscleGroups.filter(item => item.seriesAmount > 0),
          exercisesCount: training.exercises.length
        }
      } catch (error) {
        return {
          name: trainings[idx] ? trainings[idx].name : 'ERRO',
          worked_muscle_groups: [],
          exercisesCount: 0
        }
      }
    },
    getAlongamentosFromWeekday (weekday, trainings) {
      var alongamentos = 0
      var idx
      try {
        idx = trainings.findIndex(training => {
          return training.weekdays.findIndex(w => w === weekday.id) !== -1
        })

        trainings[idx].exercises.forEach(trainingExercise => {
          if (trainingExercise.exercise.exercise_type === 'resistence') {
            alongamentos += parseInt(trainingExercise.series) || 1
          }
        })

        return alongamentos
      } catch (error) {
        return 0
      }
    },
    closeConfirmationLibraryDialog () {
      this.confirmationDialogLibrary = false
    }
  },
  computed: {
    ...mapGetters('admin', ['adminTrainingDialog', 'trainingToBeEvaluated']),
    ...mapGetters('auth', ['user']),
    trainingToBeEvaluatedId () {
      return this.trainingToBeEvaluated.id
    },
    aerobicExercises () {
      return trainingIndex => {
        try {
          return filter(this.trainingToBeEvaluated.trainings[trainingIndex].exercises,
            (item) => item.exercise.exercise_type === 'aerobic') || []
        } catch (error) {
          return []
        }
      }
    },
    hiitExercises () {
      return trainingIndex => {
        try {
          return filter(this.trainingToBeEvaluated.trainings[trainingIndex].exercises,
            (item) => item.exercise.exercise_type === 'hiit') || []
        } catch (error) {
          return []
        }
      }
    },
    stretchingExercises () {
      return trainingIndex => {
        try {
          return this.trainingToBeEvaluated.trainings[trainingIndex].exercises
            .filter(item => {
              if (Array.isArray(item.exercise)) {
                return item.exercise.every(ex => ex.exercise_type === 'stretching')
              }
              return item.exercise && item.exercise.exercise_type === 'stretching'
            }) || []
        } catch (error) {
          return []
        }
      }
    },
    mobilityExercises () {
      return trainingIndex => {
        try {
          return this.trainingToBeEvaluated.trainings[trainingIndex].exercises
            .filter(item => {
              if (Array.isArray(item.exercise)) {
                return item.exercise.every(ex => ex.exercise_type === 'mobility')
              }
              return item.exercise && item.exercise.exercise_type === 'mobility'
            }) || []
        } catch (error) {
          return []
        }
      }
    },
    myofascialReleaseExercises () {
      return trainingIndex => {
        try {
          return this.trainingToBeEvaluated.trainings[trainingIndex].exercises
            .filter(item => {
              if (Array.isArray(item.exercise)) {
                return item.exercise.every(ex => ex.exercise_type === 'myofascial_release')
              }
              return item.exercise && item.exercise.exercise_type === 'myofascial_release'
            }) || []
        } catch (error) {
          return []
        }
      }
    },
    resistanceExercises () {
      return trainingIndex => {
        try {
          return this.trainingToBeEvaluated.trainings[trainingIndex].exercises
            .filter(item => {
              if (Array.isArray(item.exercise)) {
                return item.exercise.every(ex => ex.exercise_type === 'resistence')
              }
              return item.exercise && item.exercise.exercise_type === 'resistence'
            }) || []
        } catch (error) {
          console.error('Erro ao filtrar exercícios resistidos:', error)
          return []
        }
      }
    },
    functionalExercises () {
      return trainingIndex => {
        try {
          return this.trainingToBeEvaluated.trainings[trainingIndex].exercises
            .filter(item => {
              if (Array.isArray(item.exercise)) {
                return item.exercise.every(ex => ex.exercise_type === 'functional')
              }
              return item.exercise && item.exercise.exercise_type === 'functional'
            }) || []
        } catch (error) {
          return []
        }
      }
    },
    respExercises () {
      return trainingIndex => {
        try {
          return this.trainingToBeEvaluated.trainings[trainingIndex].exercises
            .filter(item => {
              if (Array.isArray(item.exercise)) {
                return item.exercise.every(ex => ex.exercise_type === 'manobra_resp')
              }
              return item.exercise && item.exercise.exercise_type === 'manobra_resp'
            }) || []
        } catch (error) {
          return []
        }
      }
    },
    respaerobic () {
      return trainingIndex => {
        try {
          return this.trainingToBeEvaluated.trainings[trainingIndex].exercises
            .filter(item => {
              if (Array.isArray(item.exercise)) {
                return item.exercise.every(ex => ex.exercise_type === 'exerc_aerobicos')
              }
              return item.exercise && item.exercise.exercise_type === 'exerc_aerobicos'
            })
            .map(v => ({
              ...v,
              aerobicocont: v.aerobicocont ? 'Sim' : 'Não'
            })) || []
        } catch (error) {
          return []
        }
      }
    },
    mesocycleIsFinished () {
      const now = new Date()
      const endDate = new Date(`${this.trainingToBeEvaluated.end_date} 23:59:59`)
      return endDate < now
    },
    isEmptyState () {
      try {
        return !(this.trainingToBeEvaluated.trainings && this.trainingToBeEvaluated.trainings.length > 0)
      } catch (error) {
        return true
      }
    },
    isStudent () {
      return this.user.isStudent()
    },
    readonly () {
      return this.mesocycleIsFinished || this.isStudent
    }
  }
}
</script>

<style lang="scss" scoped>
@media (min-width: 1264px) {
  .container {
    max-width: 1264px;
  }
}

.lightgrey {
  background-color: #E6E6E6;
}

.training-tabs {
  border-bottom: solid grey 1px;

  .v-tab--active {
    color: grey !important;
  }
}
</style>
